<!-- filepath: /resources/assets/js/components/App.vue -->
<template>
    
        <!-- ルーターのビューを表示 -->
        <router-view></router-view>
    
</template>
  
  <script>
  import { defineComponent } from 'vue';
  
  export default defineComponent({
    name: 'App',
  });
  </script>
  
  <style>
  /* スタイルの定義 */
  </style>